import { APIClient } from "../../helpers/apiClient";

import { SET_FLOWS } from "./constants";

const apiClient = new APIClient();
const { get } = apiClient;

export const setFlows = (flows) => {
  return {
    type: SET_FLOWS,
    payload: flows,
  };
};

export const getFlows = (groupId) => async (dispatch) => {
  try {
    const response = await get(`${process.env.REACT_APP_BRIDGE_FLOWS_URL}/n8n/get-workflows/${groupId}`);
    if (Array.isArray(response) && response.length > 0) {
      dispatch(setFlows(response));
    } else {
      dispatch(setFlows([]));
    }
  } catch (e) {
    console.log(e);
    dispatch(setFlows([]));
  }
};
